export type Language = 'it' | 'en' | 'es' | 'fr' | 'de';

export interface LanguageOption {
  code: Language;
  label: string;
  flag: string;
}

export const LANGUAGES: LanguageOption[] = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

export interface Translations {
  sidebar: {
    welcome: string;
    logout: string;
    closeMenu: string;
    openMenu: string;
    menuItems: Record<string, string>;
  };
  profile: {
    tabs: {
      profile: string;
      settings: string;
      company: string;
    };
    header: {
      name: string;
      role: string;
      city: string;
      notDefined: string;
    };
    roles: {
      admin: string;
      organizer: string;
      pr: string;
      collaboratore: string;
    };
    form: {
      name: string;
      email: string;
      phone: string;
      city: string;
      emailReadonly: string;
      phonePlaceholder: string;
      cityPlaceholder: string;
      changePassword: string;
      newPassword: string;
      confirmPassword: string;
      newPasswordPlaceholder: string;
      confirmPasswordPlaceholder: string;
      saving: string;
      save: string;
    };
    settings: {
      notifications: string;
      emailNotifications: string;
      pushNotifications: string;
      eventReminders: string;
      security: string;
      twoFactor: string;
      language: string;
      languageDescription: string;
    };
    company: {
      title: string;
      companyName: string;
      email: string;
      phone: string;
    };
    messages: {
      passwordMismatch: string;
      passwordTooShort: string;
      updateSuccess: string;
      updateError: string;
    };
  };
  homepage: {
    title: string;
    loading: string;
    stats: {
      totalEvents: string;
      participants: string;
      locations: string;
      matches: string;
      totalClients: string;
      totalRevenue: string;
      showRevenue: string;
      hideRevenue: string;
    };
    recentEvents: string;
    upcomingEvents: string;
    table: {
      eventName: string;
      ageRange: string;
      date: string;
      location: string;
      city: string;
      participants: string;
      matches: string;
      menRevenue: string;
      womenRevenue: string;
      total: string;
      men: string;
      women: string;
    };
    noEvents: string;
    eventStatus: {
      soldOut: string;
      almostFull: string;
      limitedSpots: string;
      scheduled: string;
    };
  };
  login: {
    brand: string;
    email: string;
    password: string;
    loggingIn: string;
    logIn: string;
    register: string;
    forgotPassword: string;
    registrationTitle: string;
    registrationDescription: string;
    fullName: string;
    registering: string;
    alreadyHaveAccount: string;
    resetPasswordTitle: string;
    resetPasswordDescription: string;
    sending: string;
    sendInstructions: string;
    backToLogin: string;
    resetEmailSent: string;
    errors: {
      invalidCredentials: string;
      emailNotConfirmed: string;
      invalidEmailFormat: string;
      genericLoginError: string;
      registrationError: string;
      resetPasswordError: string;
    };
  };
  auth: {
    pendingApproval: string;
    accountRejected: string;
    accountSuspended: string;
    registrationComplete: string;
  };
  common: {
    loading: string;
    error: string;
    close: string;
    cancel: string;
    confirm: string;
    save: string;
    delete: string;
    edit: string;
    add: string;
    search: string;
    noResults: string;
    back: string;
    next: string;
    hiddenAmount: string;
  };
}
